import { invokeApi } from "src/bl_libs/invokeApi";

/**
 * Coach workspace APIs (client video + design PDF, Nov 2026).
 * Backend: bms-backend/routes/coach_workspace.js → /api/coach_workspace/*
 */

const auth = () => ({ "x-sh-auth": localStorage.getItem("token") });
const browserTz = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch (_err) {
    return "";
  }
};
const qs = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") search.set(key, value);
  });
  const text = search.toString();
  return text ? `?${text}` : "";
};

const get = (path) => invokeApi({ path, method: "GET", headers: auth() });
const post = (path, data = {}) => invokeApi({ path, method: "POST", headers: auth(), postData: data });
const put = (path, data = {}) => invokeApi({ path, method: "PUT", headers: auth(), postData: data });

// 2.4 Today
export const getCoachTodayApi = (params = {}) =>
  get(`api/coach_workspace/today${qs({ tz: browserTz(), ...params })}`);

// 2.1 / 2.2 / 2.5 review page
export const getReviewContextApi = (submissionId) =>
  get(`api/coach_workspace/review/${submissionId}${qs({ tz: browserTz() })}`);
export const saveReviewChecklistApi = (submissionId, checklist) =>
  post(`api/coach_workspace/review/${submissionId}/checklist`, checklist);
export const completeReviewWorkApi = (submissionId, checklist) =>
  post(`api/coach_workspace/review/${submissionId}/complete`, checklist);
export const exceptFeedbackApi = (submissionId, reason = "") =>
  post(`api/coach_workspace/review/${submissionId}/except`, { reason });
export const skipReviewApi = (submissionId, reason = "") =>
  post(`api/coach_workspace/review/${submissionId}/skip`, { reason });
export const snoozeAttentionApi = (data) => post(`api/coach_workspace/attention/snooze`, data);

// 3.4 programme week + comments
export const getClientWeekApi = (memberId, date) =>
  get(`api/coach_workspace/client/${memberId}/week${qs({ date, tz: browserTz() })}`);
export const getClientCommentsApi = (memberId, type = "all") =>
  get(`api/coach_workspace/client/${memberId}/comments${qs({ type })}`);

// 1.5 / 1.7 / 2.3 person schedule
export const getPersonScheduleApi = (trackerId, { personKey, memberId } = {}) =>
  get(`api/coach_workspace/schedule/${trackerId}${qs({ personKey, memberId })}`);
export const previewScheduleChangeApi = (data) => post(`api/coach_workspace/schedule/preview`, data);
export const saveScheduleChangeApi = (data) => post(`api/coach_workspace/schedule/save`, data);
export const skipCheckInApi = (data) => post(`api/coach_workspace/schedule/skip`, data);
export const unskipCheckInApi = (data) => post(`api/coach_workspace/schedule/unskip`, data);
export const saveReviewPlanApi = (data) => post(`api/coach_workspace/schedule/review_plan`, data);

// 3.7 weekly planner
export const getPlannerApi = (params = {}) =>
  get(`api/coach_workspace/planner${qs({ tz: browserTz(), ...params })}`);

// 1.8 check-in rules (read for coach; PUT is admin only)
export const getTrackerRulesApi = (trackerId) => get(`api/coach_workspace/tracker_rules/${trackerId}`);
export const updateTrackerRulesApi = (trackerId, data) =>
  put(`api/coach_workspace/tracker_rules/${trackerId}`, data);

// 5.1 / 5.2 check-in questions: draft → review → publish
export const getQuestionsApi = (trackerId) => get(`api/coach_workspace/questions/${trackerId}`);
export const saveQuestionDraftApi = (trackerId, forms) =>
  put(`api/coach_workspace/questions/${trackerId}/draft`, { forms });
export const discardQuestionDraftApi = (trackerId) => post(`api/coach_workspace/questions/${trackerId}/discard`);
export const publishQuestionsApi = (trackerId, data) => post(`api/coach_workspace/questions/${trackerId}/publish`, data);

// Check-in settings for ALL journeys (late submit, day change) — admin
export const getCheckInSettingsApi = () => get(`api/coach_workspace/settings`);
export const updateCheckInSettingsApi = (data) => put(`api/coach_workspace/settings`, data);
